<template>
  <div class="visionboard-sidebar">
    <p class="no-content" v-if="selection.type === null">
      Please select something.
    </p>
    <template v-else-if="selection.type === 'group'">
      <GoalSettings
        :key="selection.goalId"
        :goal-id="selection.goalId" />
    </template>
    <template v-else-if="selection.type === 'text'">
      <TextSettings
        :key="selection.textId"
        :text-id="selection.textId"
        :text-data="selection.data"
        @save="onHandleTextUpdate"
        @delete="onHandleTextDelete" />
    </template>
    <template v-else-if="selection.type === 'quote'">
      QUOTE
    </template>
    <template v-else-if="selection.type === 'clock'">
      CLOCK
    </template>
    <pre class="mini-pre">selection: {{selection}}</pre>
    <el-button class="btn-block d-block mx-auto w-50" @click="toggleVisionboardEditMode">Exit edit mode</el-button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TextSettings from "./Sidebar/TextSettings"
import GoalSettings from "./Sidebar/GoalSettings"

export default {
  props: {
    selection: {},
  },
  data: () => ({
  }),
  /*
  watch: {
    selection: {
      handler() {
        console.log("selection.type === '",this.selection.type,"'", this.$refs)

        if ( this.selection.type === 'text' && this.$refs.textSettings) {
          this.$refs.textSettings.showUpdateModal(this.selection)
        }
        if ( this.selection.type === 'group' && this.$refs.goalSettings) {
          this.$refs.goalSettings.showUpdateModal(this.selection)
        }
      },
      deep: true
    }
  },
  */
  methods: {
    ...mapActions("app", [
      'toggleVisionboardEditMode'
    ]),

    onHandleTextUpdate( $event ) {
      this.$emit('text-update', { action: 'update', data: $event } )
    },

    onHandleTextDelete( $event ) {
      this.$emit('text-update', { action: 'delete', data: $event } )
    }
  },
  components: {
    TextSettings,
    GoalSettings,
  }
}
</script>

<style>
.visionboard-sidebar {
  margin: 6px;
}
.visionboard-sidebar .el-form-item {
  margin-bottom: 0;
  line-height: 1;
}
.visionboard-sidebar .el-form-item__label,
.visionboard-sidebar .el-form-item__content {
  padding-bottom: 5px;
  line-height: 26px;
}
</style>
